<template>
<div id="kvartalalley">
  <div id="app">
    <kvartalalley msg="Welcome to Your Vue.js App"/>
  </div>
</div>
</template>

<script>
import kvartalalley from './components/kvartalalley.vue'

export default {
  name: 'app',
  components: {
      kvartalalley
  }
}
</script>

<style>
/*#app {*/
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*text-align: center;*/
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/
/*}*/
</style>
